import { __extends } from "tslib";
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: IOErrorEvent
var HTTPStatusEvent = /** @class */ (function (_super) {
    __extends(HTTPStatusEvent, _super);
    function HTTPStatusEvent(type, bubbles, cancelable, _status, _redirected) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (_status === void 0) { _status = 0; }
        if (_redirected === void 0) { _redirected = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._status = _status;
        _this._redirected = _redirected;
        _this._responseURL = '';
        _this._responseHeaders = null;
        return _this;
    }
    /**
     * @description Undocumented method!
     */
    HTTPStatusEvent.prototype._setStatus = function (v) {
        this._status = v;
    };
    Object.defineProperty(HTTPStatusEvent.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTTPStatusEvent.prototype, "redirected", {
        get: function () {
            return this._redirected;
        },
        set: function (v) {
            this._redirected = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTTPStatusEvent.prototype, "responseURL", {
        get: function () {
            return this._responseURL;
        },
        set: function (v) {
            this._responseURL = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTTPStatusEvent.prototype, "responseHeaders", {
        get: function () {
            return this._responseHeaders;
        },
        set: function (value) {
            this._responseHeaders = value;
        },
        enumerable: true,
        configurable: true
    });
    HTTPStatusEvent.prototype.clone = function () {
        return new HTTPStatusEvent(this.type, this.bubbles, this.cancelable, this._status, this._redirected);
    };
    HTTPStatusEvent.prototype.toString = function () {
        return this.formatToString('IOErrorEvent', 'type', 'bubbles', 'cancelable', 'text', 'errorID');
    };
    HTTPStatusEvent.classInitializer = null;
    // JS -> AS Bindings
    HTTPStatusEvent.HTTP_RESPONSE_STATUS = 'httpResponseStatus';
    HTTPStatusEvent.HTTP_STATUS = 'httpStatus';
    return HTTPStatusEvent;
}(Event));
export { HTTPStatusEvent };
